import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import '@/assets/scss/_base.scss'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import IconSvg from '@/components/icon-svg/index.vue'
import '@/icons'
import { isAuth } from '@/utils'

const app = createApp(App)

/* ========== ✅ 正确方式 ========== */
app.config.warnHandler = (msg, vm, trace) => {
  if (
    msg.includes('Invalid prop') ||
    msg.includes('custom validator check failed')
  ) {
    return
  }
  console.warn(`[Vue warn]: ${msg}\n${trace}`)
}

/* ========== 全局属性 ========== */
app.config.globalProperties.isAuth = isAuth

/* ========== 插件 ========== */
app.use(createPinia())
app.use(router)
app.use(ElementPlus, { locale: zhCn })
// ✅ 全局注册图标
Object.keys(ElementPlusIconsVue).forEach(key => {
  app.component(key, ElementPlusIconsVue[key])
})

/* ========== 全局组件 ========== */
app.component('IconSvg', IconSvg)

app.mount('#app')